import Backbone from 'backbone'
import $ from 'jquery'
import template from './file-selector.hbs'
import readFile from 'scoreboard/components/read-file'
import FileLibrary from 'scoreboard/components/files/file-library'
import appDisplay from 'scoreboard/components/app-display'
import ImageLibraryObjectSelector from 'scoreboard/components/files/image-library-object-selector'
import Tooltip from 'scoreboard/components/tooltip'
import fileInfo from 'scoreboard/components/files/file-info'
import fileExtensionValidatorFactory from 'scoreboard/components/validators/file-extension-validator-factory'

const FileSelector = Backbone.View.extend({

	className: 'file-selector',

	events: {
		'click .add-shared-image': 'addSharedImage',
		'click .upload-image': 'upload',
		'change .image-file': 'onChangeImageFile'
	},

	render: function () {
		this.$el.append(template({ accept: fileInfo.accepts['image'] }))
		return this
	},

	// Trigger the file upload selection when the upload button is clicked
	upload: function() {
		this.$('.image-file').click()
	},

	onChangeImageFile: function (e) {
		let files = e.target.files
		if (!this.validatePickedFile(files)) {
			readFile(files, this._picked.bind(this))
		}
	},

	_picked: function (filename, dataUri) {
		this.trigger('pick', {
			dataUri: dataUri,
			name: filename
		})
	},

	/**
	 * Validates whether the file picked from the file input is a valid. Returns
	 * an error message if there is one, or null if it is valid
	 */
	validatePickedFile: function (files) {
		this.removeErrorTooltip()

		let file = files[0]
		let error = imageExtensionValidator(file.name)

		if (error) {
			// #22601 There is no input field to use MarkedField on, so just pop
			// up a tooltip on the Upload Image button with the error
			this.errorTooltip = new Tooltip({
				attachTo: this.$('.upload-image'),
				placement: 'above',
				arrow: 'center',
				extraClass: 'has-error',
				content: error
			}).render()

			return error
		} else {
			return null
		}
	},

	addSharedImage() {
		let library = new FileLibrary({
			ObjectSelector: ImageLibraryObjectSelector
		})
		appDisplay.dialog(library)
		library.on('done', metadata => this.trigger('addSharedImage', metadata))
	},

	removeErrorTooltip: function () {
		this.errorTooltip && this.errorTooltip.remove()
		delete this.errorTooltip
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeErrorTooltip()
	}
})

const imageExtensionValidator = fileExtensionValidatorFactory(['image'])

export default FileSelector

FileSelector.__filename__ = 'dashboards/widgets/image/file-selector.js'
